import { Controller } from "react-hook-form";

import CustomAutocomplete from "./customAutocomplete";

export default function ControlledAutocomplete({
  name = "",
  control = null,
  defaultValue = null,
  options,
  multiple = false,
  loading = false,
  disabled = false,
  label = "",
  placeholder = "",
  size="small",
  variant = "outlined",
  shrink = true,
  sx = {},
  getOptionLabel = (option) => option.label ?? option,
  getOptionKey = (option) => option.label ?? option,
  isOptionEqualToValue = (option, value) => option === value,
  groupBy= null,
  renderOption = null,
  rules = null,
  disableClearable = false,
}) {
  return (
    <Controller
      name={name}
      disabled={disabled}
      control={control}
      defaultValue={null}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <CustomAutocomplete 
          label={label}
          placeholder={placeholder}
          value={field.value}
          onChange={field.onChange}
          defaultValue={defaultValue}
          options={options}
          multiple={multiple}
          loading={loading}
          disabled={disabled}
          error={error}
          helperText={error ? error.message : ""}
          size={size}
          variant={variant}
          shrink={shrink}
          sx={sx}
          getOptionKey={getOptionKey}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          groupBy={groupBy}
          renderOption={renderOption}
          disableClearable={disableClearable}
        />
    )}
  />
  )
}